export const VentilationLevels = ["Low", "Medium", "High", "Timer"]
